"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.createSubmitCQAWorkItemHandler = exports.createSubmitCaseHandler = exports.mapDispatchToCodeBenchActionBarProps = exports.mapStateToCodeBenchActionBarProps = void 0;
var ui_common_1 = require("@codametrix/ui-common");
var navigatePatient = ui_common_1.codeBenchActions.navigatePatient, navigateDetail = ui_common_1.codeBenchActions.navigateDetail, showHoldCaseModal = ui_common_1.codeBenchActions.showHoldCaseModal, hideHoldCaseModal = ui_common_1.codeBenchActions.hideHoldCaseModal, showExclusionCaseModal = ui_common_1.codeBenchActions.showExclusionCaseModal, hideExclusionCaseModal = ui_common_1.codeBenchActions.hideExclusionCaseModal, showSplitCaseModal = ui_common_1.codeBenchActions.showSplitCaseModal, hideSplitCaseModal = ui_common_1.codeBenchActions.hideSplitCaseModal, navigate = ui_common_1.codeBenchActions.navigate, toggleSubmitOldCaseModal = ui_common_1.codeBenchActions.toggleSubmitOldCaseModal, getCaseVersions = ui_common_1.codeBenchActions.getCaseVersions, showCaseCommentModal = ui_common_1.codeBenchActions.showCaseCommentModal, hideCaseCommentModal = ui_common_1.codeBenchActions.hideCaseCommentModal, openWindow = ui_common_1.codeBenchActions.openWindow;
var showMergeCasesModal = ui_common_1.mergeCasesActions.showMergeCasesModal, hideMergeCasesModal = ui_common_1.mergeCasesActions.hideMergeCasesModal, splitCase = ui_common_1.mergeCasesActions.splitCase;
var mapStateToCodeBenchActionBarProps = function (state) {
    return {
        activeItem: state.codeBench.activeItem,
        loadState: state.codeBench.loadState,
        processInstanceGuids: state.ui.contextParams.processInstanceGuids || [],
        processInstance: state.codeBench.processInstance,
        cases: state.codeBench.cases,
        counts: state.codeBench.counts,
        benchEditable: state.codeBench.benchEditable,
        toggleHoldCaseModal: state.codeBench.toggleHoldCaseModal,
        toggleExclusionCaseModal: state.codeBench.toggleExclusionCaseModal,
        toggleSplitCaseModal: state.codeBench.toggleSplitCaseModal,
        submitOldCaseModal: state.codeBench.submitOldCaseModal,
        holdCaseStatus: state.codeBench.holdCase,
        improvements: state.codeBench.improvements,
        userContext: state.codeBench.userContext,
        caseAccessTime: state.codeBench.caseAccessTime,
        benchMode: state.codeBench.benchMode
    };
};
exports.mapStateToCodeBenchActionBarProps = mapStateToCodeBenchActionBarProps;
var mapDispatchToCodeBenchActionBarProps = function (dispatch) {
    return {
        openChildWindow: function (windowOpenArgs) {
            dispatch(openWindow(windowOpenArgs));
        },
        showPatientInfo: function (caseRun) {
            dispatch(navigatePatient(caseRun));
        },
        handleTraversal: function (caseDescriptor) {
            dispatch(navigateDetail(caseDescriptor));
        },
        showHoldCaseModal: function () {
            dispatch(showHoldCaseModal());
        },
        hideHoldCaseModal: function () {
            dispatch(hideHoldCaseModal());
        },
        showCaseCommentModal: function () {
            dispatch(showCaseCommentModal());
        },
        hideCaseCommentModal: function () {
            dispatch(hideCaseCommentModal());
        },
        showMergeCasesModal: function (mergeCaseModalProps) {
            dispatch(showMergeCasesModal(mergeCaseModalProps));
        },
        hideMergeCasesModal: function () {
            dispatch(hideMergeCasesModal());
        },
        showExclusionCaseModal: function () {
            dispatch(showExclusionCaseModal());
        },
        hideExclusionCaseModal: function () {
            dispatch(hideExclusionCaseModal());
        },
        showSplitCaseModal: function () {
            dispatch(showSplitCaseModal());
        },
        hideSplitCaseModal: function () {
            dispatch(hideSplitCaseModal());
        },
        navigate: function (url) {
            dispatch(navigate(url));
        },
        toggleSubmitOldCaseModal: function () {
            dispatch(toggleSubmitOldCaseModal());
        },
        getCaseVersions: function (processInstance) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(getCaseVersions(processInstance))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        splitCase: function (processInstance) {
            dispatch(splitCase(processInstance));
        }
    };
};
exports.mapDispatchToCodeBenchActionBarProps = mapDispatchToCodeBenchActionBarProps;
var ui_common_2 = require("@codametrix/ui-common");
var CursorOperation = ui_common_2.commonEnums.CursorOperation;
function createSubmitCaseHandler(UIMode, onInvoicesSubmisson, processInstance, cursorAPIContext, caseAccessTime, activeItem, getCaseVersions, toggleSubmitOldCaseModal, hasAmplifyCaseRunV2Access) {
    var _this = this;
    return function (event, vwComment, isCodeableVersion) {
        if (vwComment === void 0) { vwComment = null; }
        return __awaiter(_this, void 0, void 0, function () {
            var button, cursorAPIPayload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        button = event.currentTarget;
                        button.disabled = true;
                        cursorAPIPayload = {
                            operation: CursorOperation.NEXT,
                            cursorAPIContext: cursorAPIContext,
                            hasAmplifyCaseRunV2Access: hasAmplifyCaseRunV2Access
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 6, 7]);
                        return [4 /*yield*/, getCaseVersions(processInstance)];
                    case 2:
                        _a.sent();
                        if (!isCodeableVersion) return [3 /*break*/, 4];
                        return [4 /*yield*/, onInvoicesSubmisson({
                                processInstance: processInstance,
                                uiMode: UIMode,
                                vwComment: vwComment,
                                cursorAPIPayload: cursorAPIPayload,
                                submitWithOverrideButton: false,
                                caseAccessTime: caseAccessTime,
                                activeItem: activeItem
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        toggleSubmitOldCaseModal('');
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        button.disabled = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
}
exports.createSubmitCaseHandler = createSubmitCaseHandler;
function createSubmitCQAWorkItemHandler(cursorAPIContext, submitWorkItem, status) {
    var _this = this;
    return function (event, vwComment, isCodeableVersion) {
        if (vwComment === void 0) { vwComment = null; }
        return __awaiter(_this, void 0, void 0, function () {
            var button, cursorAPIPayload;
            return __generator(this, function (_a) {
                event.preventDefault();
                button = event.currentTarget;
                button.disabled = true;
                cursorAPIPayload = {
                    operation: CursorOperation.NEXT,
                    cursorAPIContext: cursorAPIContext
                };
                try {
                    submitWorkItem(cursorAPIPayload, status);
                }
                finally {
                    button.disabled = false;
                }
                return [2 /*return*/];
            });
        });
    };
}
exports.createSubmitCQAWorkItemHandler = createSubmitCQAWorkItemHandler;
//# sourceMappingURL=code-bench-action-bar-component-utilities.js.map